var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import id from "@irati/utils/id";
import ErrorText from "@irati/ui/src/ErrorText";
import { Hidden } from "@irati/ui/src/FormItem";
import { Recognition as RecognitionField } from "@irati-web/fields/poll/votes";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { recognitionSchema } from "@irati-web/fields/poll/votes/validation";
import UpdatePollVoteMutation from "@irati/recognition/apollo/mutation/Vote/Update";
import { ButtonsContainer, CancelButton, ValidationButton } from "../Buttons";
import { Form } from "../layouts";
var UpdateVote = /** @class */ (function (_super) {
    __extends(UpdateVote, _super);
    function UpdateVote(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (message) { return _this.setState({ message: message }); };
        _this.state = {
            message: props.vote.message
        };
        return _this;
    }
    UpdateVote.prototype.render = function () {
        var _this = this;
        var _a = this.props, poll = _a.poll, vote = _a.vote, onClickCancel = _a.onClickCancel, onUpdateSuccess = _a.onUpdateSuccess, intl = _a.intl;
        var message = this.state.message;
        return (React.createElement(UpdatePollVoteMutation, { poll: poll, vote: vote, message: message, onCompleted: onUpdateSuccess }, function (onClick, apolloState) { return (React.createElement(Form, null,
            React.createElement(RecognitionField, { onChange: _this.handleChange, value: message }),
            React.createElement(Hidden, { id: id("hidden-recognition", _this.props), name: id("hidden-recognition", _this.props), value: message, validation: recognitionSchema(intl) }),
            apolloState.error && (React.createElement(ErrorText, null, apolloState.errorMsg)),
            React.createElement(ButtonsContainer, null,
                React.createElement(CancelButton, { id: id("cancel", _this.props), type: "button", onClick: onClickCancel },
                    React.createElement(FormattedMessage, { id: "recognition.popup.votes.updateVote.cancelButton" })),
                React.createElement(ValidationButton, { id: id("submit", _this.props), onClick: onClick, apolloState: apolloState, full: true, primary: true },
                    React.createElement(FormattedMessage, { id: "recognition.popup.votes.updateVote.saveButton" }))))); }));
    };
    UpdateVote.defaultProps = {
        id: "update-vote"
    };
    return UpdateVote;
}(Component));
export default injectIntl(UpdateVote);
